import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
import type React from 'react';
export type BannerVariant = 'error' | 'warning' | 'info' | 'announcement';
export type BannerProps = React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof banner> & {
  children: React.ReactNode;
  variant: BannerVariant;
};
const Banner = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      variant,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== variant) {
    t1 = banner({
      variant,
      className
    });
    $[5] = className;
    $[6] = variant;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== props || $[10] !== t1) {
    t2 = <div role="alert" className={t1} {...props}>{children}</div>;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
const banner = cva(['w-full text-center px-4 py-3 text-label-2', '[&_button:not(:disabled)]:cursor-pointer', '[&_a:hover]:opacity-70 [&_button:hover]:opacity-70', '[&_a:active]:opacity-85 [&_button:active]:opacity-85', '[&_a]:underline [&_button]:underline', '[&_a]:ml-1 [&_button]:ml-1'], {
  variants: {
    variant: {
      error: ['bg-error text-error', '[&>a]:text-error [&>button]:text-error'],
      info: ['bg-info text-info', '[&>a]:text-info [&>button]:text-info'],
      warning: ['bg-warning text-warning', '[&>a]:text-warning [&>button]:text-warning'],
      announcement: ['bg-primary text-primary', '[&>a]:text-accent [&>button]:text-accent']
    }
  },
  defaultVariants: {
    variant: 'info'
  }
});
export default Banner;